var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlashinline = function SvgFlashinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.079 13.09a.44.44 0 0 1-.263-.468l.797-5.184H3.5a.437.437 0 0 1-.438-.538l1.313-5.688a.44.44 0 0 1 .437-.337h4.375a.437.437 0 0 1 .429.534l-.757 3.404h2.078a.44.44 0 0 1 .394.245.44.44 0 0 1-.048.437l-5.688 7.438a.44.44 0 0 1-.345.192.5.5 0 0 1-.171-.035"
  })));
};
export default SvgFlashinline;